import { passwordUser, editUserActive } from "../../../api/users/detail/userSummery.js";
import { Avatar, Button, CircularProgress, Switch } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Modal, TextInput, UploadImage } from "../../../../../shared/ui/common/index.js";
import DateDisplay from "../../../../../shared/ui/common/date.jsx";

import { Confirm } from "../../../../../shared/ui/modals/index.js";
import { baseUrl, DOWNLOAD_FILE } from "../../../../../shared/api/endpoints.js";


const UserSummery = ({
  userData,
  avatar,
  setAvatar,
  selectedProductImage,
  setselectedProductImage,
}) => {
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [loading, setLoading] = useState({});
  const { token } = useSelector((state) => state.user);
  const { userPermissions } = useSelector((state) => state.relationals);
  const [isActive, setisActive] = useState(false);
  const [passWord, setPassWord] = useState("");
  useEffect(() => {
    setisActive(userData?.active);
  }, [userData]);
  const sendPassword = () => {
    setLoading({ password: true });
    var data = {
      id: userData?.id,
      newPassword: passWord,
    };
    passwordUser(data, token)
      .then((res) => {
        toast.success("رمز عبور با موفقیت تغییر کرد");
        setLoading({ password: false });
        setOpen2(false);
      })
      .catch((err) => {
        setLoading({ password: false });
        toast.error(err.response?.data?.message);
      });
  };
  const submitEdit = () => {
    setLoading({ active: true });
    editUserActive(userData, token)
      .then((res) => {
        toast.success('با موفقیت تغییر کرد');
        setLoading({ active: false });
        setisActive(!isActive)
        setOpen(false);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err.response?.data?.message);
        setLoading({ active: false });
      });
  };
  const navigate = useNavigate();
  const deleteUser = () => {
    deleteUser(userData, token)
      .then((res) => {
        toast.success("با موفقیت حذف شد");
        setLoading(false);
        navigate("/users");
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err.response?.data?.message);
      });
  };
  const changeLegal = (e) => {
    /*     axios
      .put(
        `${baseUrl}/${EDIT_USER}`,
        { ...userData, isLegal: e },
          {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((res) => {
        toast.success(`با موفقیت ${e ? "حقیقی" : "حقوقی"} کاربرشد`);
        setIslegal(e);
      })
      .catch((err) => {
        toast.error(err.response?.data?.message);
      }); */
  };
  return (
    <div className="flex flex-col items-center py-6 gap-2">
      <Avatar sx={{ bgcolor: "#13318f", width: 75, height: 75 }}>
        {userData?.galleryId ? (
          <>
            <img
              src={`${baseUrl}/${DOWNLOAD_FILE}/${userData?.galleryId}`}
              alt=""
              className="w-[75px] h-[75px] rounded-full"
            />
          </>
        ) : (
          <>
            {userData?.fname?.slice(0, 1)} {userData?.lname?.slice(0, 1)}
          </>
        )}
      </Avatar>
      <div className="z-50 relative">
        {" "}
        <UploadImage
          key={`${userData?.id}-${userData?.galleryId}`} disabled={!userData?.id}
          file={avatar}
          change={setAvatar}
          /*  address={userData.galleryId} */
          selectedProductImage={selectedProductImage}
          setselectedProductImage={setselectedProductImage}
          icons={true}
        />
      </div>
      {/*       <div className="text-xs text-[#93989e] mt-5 border rounded-2xl border-[#d4dae3] py-1 px-3">
        {userData?.role === 0 ? "کاربر" : userData?.access || "ادمین"}
      </div> */}
      <div className="text-[#364a63] text-base font-semibold">
        {userData?.fname} {userData?.lname}
      </div>
      <span className="text-xs text-[#8094ae]">{userData?.mobile}</span>
      <div className="flex flex-col px-3 pt-4 pb-3 gap-2 border-t w-full mx-3">
        <div className="flex justify-between items-center gap-2">
          <span className="text-xs text-[#8094ae]"> کد کاربری : </span>
          <span className="text-xs text-[#000] font-bold">{userData?.id}</span>
        </div>
        <div className="flex justify-between items-center gap-2">
          <span className="text-xs text-[#8094ae]"> آخرین ورود: </span>
          <span className="text-xs -ml-2 text-[#000] font-bold">
            <DateDisplay date={userData?.lastLogin} />
          </span>
        </div>
        <div className="flex justify-between items-center gap-2">
          <span className="text-xs text-[#8094ae]"> حساب کاربری: </span>
          <Switch
            onClick={() => setOpen(true)}
            /*  color="success" */
            checked={Boolean(isActive)}
          />
        </div>
      </div>

      <div className="flex justify-center  items-center pt-4 gap-2 border-t w-full mx-3">
        <Button
          onClick={() => setOpen3(true)}
          sx={{ width: "140px" }}
          variant="outlined"
          color="error"
        >
          حذف
        </Button>

        <Button
          onClick={() => setOpen2(true)}
          sx={{
            color: "#364a63 !important",
            borderColor: "#364a63 !important",
            width: "140px",
          }}
          variant="outlined"
        >
          تغییر پسورد کاربر
        </Button>
      </div>

      <Modal
        open={open}
        close={() => {
          setOpen(false);
        }}
        title={`آیا از تغییر وضعیت کاربر   اطمینان دارید ؟ `}
      >
        <div className="flex justify-center gap-4 items-center">
          <Button
            disabled={loading?.active}
            onClick={submitEdit}
            variant="contained"
          >
            {loading?.active ? <CircularProgress /> : <>ثبت اطلاعات</>}
          </Button>
          <Button
            onClick={() => {
              setOpen(false);
            }}
            color="error"
            variant="contained"
          >
            انصراف
          </Button>
        </div>
      </Modal>
      <Modal
        open={open2}
        close={() => {
          setOpen2(false);
          setPassWord("");
        }}
        title="انتخاب  پسورد جدید"
      >
        <div className="flex justify-center gap-4 items-center">
          <TextInput
            label=" پسورد"
            currentValue={passWord}
            change={(e) => setPassWord(e)}
          />
        </div>
        <Button
          disabled={loading?.password || !passWord}
          onClick={sendPassword}
          variant="contained"
        >
          {loading?.password ? <CircularProgress /> : <>ثبت اطلاعات</>}
        </Button>
      </Modal>
      <Confirm
        message={`آیا از  حذف این  کاربر   اطمینان دارید ؟ `}
        close={() => setOpen3(false)}
        submit={deleteUser}
        open={open3}
      />
    </div>
  );
};

export default UserSummery;
